import { IManufacturer } from 'partsOld/types';

export enum ManufacturerType {
  SINGLE = 'single_manufacturer',
  MULTIPLE = 'multiple_manufacturers',
}

export interface ICostManufacturerForm {
  costStartDate: Date;
  costEndDate: Date;
  manufacturer: IManufacturer;
  manufacturerType: ManufacturerType;
}
